import React, { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { getBrandRequest } from "../../Containers/Product/Product-slice";

const Brands = ({ getBrandRequest, branddata }) => {
  const [activeFilter, setActiveFilter] = useState("All");

  useEffect(() => {
    getBrandRequest();
  }, []);

  const filters = [
    "All",
    "0-9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
  ];

  /* ===============================
     GROUP BRANDS DYNAMICALLY
  =============================== */
  const brandsData = useMemo(() => {
    const grouped = {};

    filters.forEach((f) => {
      if (f !== "All") grouped[f] = [];
    });

    if (Array.isArray(branddata)) {
      branddata.forEach((brand) => {
        if (!brand?.name) return;

        const firstChar = brand.name.charAt(0).toUpperCase();

        const key =
          firstChar >= "0" && firstChar <= "9"
            ? "0-9"
            : firstChar >= "A" && firstChar <= "Z"
            ? firstChar
            : null;

        if (key && grouped[key]) {
          grouped[key].push({
            name: brand.name,
            logo: brand.image_url,
          });
        }
      });
    }

    return grouped;
  }, [branddata]);

  const handleFilterClick = (filter) => {
    setActiveFilter(filter);
    if (filter === "All") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      const element = document.getElementById(`section-${filter}`);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  };

  return (
    <div style={styles.container}>
      {/* Filter Bar */}
      <div style={styles.filterBar}>
        {filters.map((filter) => (
          <button
            key={filter}
            onClick={() => handleFilterClick(filter)}
            style={{
              ...styles.filterButton,
              ...(activeFilter === filter ? styles.activeFilter : {}),
            }}
          >
            {filter}
          </button>
        ))}
      </div>

      {/* Brand Sections */}
      <div style={styles.content}>
        {Object.entries(brandsData).map(([key, brands]) =>
          brands.length ? (
            <div key={key} id={`section-${key}`} style={styles.section}>
              <h2 style={styles.sectionTitle}>{key}</h2>

              <div style={styles.grid}>
                {brands.map((brand, index) => (
                  <div key={index} style={styles.card}>
                    <div style={styles.logoContainer}>
                      <img
                        src={brand.logo}
                        alt={brand.name}
                        style={styles.logo}
                        onError={(e) => (e.target.style.display = "none")}
                      />
                    </div>
                    <p style={styles.brandName}>{brand.name}</p>
                  </div>
                ))}
              </div>
            </div>
          ) : null
        )}
      </div>
    </div>
  );
};

/* ===============================
   STYLES (UNCHANGED)
================================ */
const styles = {
  container: {
    padding: "20px",
    backgroundColor: "#f8f9fa",
    minHeight: "100vh",
  },
  filterBar: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "5px",
    marginBottom: "30px",
    padding: "10px",
    backgroundColor: "#fff",
    position: "sticky",
    top: "0",
    zIndex: "100",
    boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
  },
  filterButton: {
    border: "none",
    background: "none",
    padding: "8px 12px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "600",
    color: "#333",
    borderRadius: "4px",
  },
  activeFilter: {
    backgroundColor: "#fff0e6",
    color: "#ff6b00",
  },
  content: {
    maxWidth: "1200px",
    margin: "0 auto",
  },
  section: {
    marginBottom: "40px",
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "8px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
  },
  sectionTitle: {
    fontSize: "18px",
    fontWeight: "bold",
    color: "#ff6b00",
    marginBottom: "20px",
    borderBottom: "1px solid #eee",
    paddingBottom: "10px",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(120px, 1fr))",
    gap: "20px",
  },
  card: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    padding: "10px",
    cursor: "pointer",
  },
  logoContainer: {
    width: "100px",
    height: "60px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "10px",
    border: "1px solid #eee",
    borderRadius: "4px",
    padding: "5px",
    backgroundColor: "#fff",
  },
  logo: {
    maxWidth: "100%",
    maxHeight: "100%",
    objectFit: "contain",
  },
  brandName: {
    fontSize: "12px",
    color: "#333",
    fontWeight: "500",
    margin: 0,
  },
};

/* ===============================
   REDUX
================================ */
const mapStateToProps = (state) => ({
  branddata: state.Product.branddata?.data,
});

const mapDispatchToProps = (dispatch) => ({
  getBrandRequest: () => dispatch(getBrandRequest()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Brands);
